import axios from "axios";

export default {
  namespaced: true,
  state: {
    courierList: []
  },
  getters: {

  },
  mutations: {
    setCourierList(state, info){
      state.courierList = info
    }
  },
  actions: {
    async getCourierList (context, info) {
      const res = await axios.post("kdniaoShipper/queryList", {})
      if(res.data.code == 200){
        context.commit("setCourierList", res.data.data)
      }
    },

  }
}
